import actions from '../../../../redux/actions/ui/dataImport/strategies/removeSupplierSKUStrategy.js'
import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default function RemoveSupplierSKUStrategy(props) {
  return (
    <BaseStrategy
      {...props}
      actions={actions}
      EditForm={EditForm}
      ReconcileForm={ReconcileForm}
    />
  )
}

RemoveSupplierSKUStrategy.title = actions.title
const option = {
  value: 'remove_supplier_sku',
  display: 'Remove Supplier SKUs',
  category: 'suppliers',
  Component: RemoveSupplierSKUStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
RemoveSupplierSKUStrategy.option = option
